import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from '../../QestIds';
import { BsEnDryMassesSection, BsEnMeasurementsSection, BsEnPreparationSection, BsEnResultsSection } from './Sections';

const qestIds = [ids.moistureContent.BS_EN_1097_5.rev2008];

const BsEnMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <BsEnPreparationSection />
    </PageSection>
    <PageSection heading="Measurements">
      <BsEnMeasurementsSection />
    </PageSection>
    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>
    <PageSection heading="Dry Mass">
      <BsEnDryMassesSection />
    </PageSection>
    <PageSection heading="Results">
      <BsEnResultsSection />
    </PageSection>
    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

BsEnMoistureContentWorksheet.qestIds = qestIds;

export default BsEnMoistureContentWorksheet;
export { BsEnMoistureContentWorksheet };
